import { elementController } from '@public-pages/runtime-core';

elementController('accordion', ({ queryAll }) => {
  const buttonList = queryAll('[data-collapse-item]');
  const contentList = queryAll('[data-collapse-content]');

  for (const button of buttonList) {
    button.addEventListener('click', handleSelectedItem);
  }

  const observableItems: any[] = [];

  function handleSelectedItem(e: Event) {
    e.preventDefault();

    const clickedItem = e.target as HTMLButtonElement;
    const itemId = clickedItem.getAttribute('data-collapse-item');

    const activeContentClass = 'accordion__content--on';
    const activeContentItemClass = 'accordion__content-item--on';
    const activeButtonClass = 'accordion__button-collapse--on';

    for (const button of buttonList) {
      const buttonId = button.getAttribute('data-collapse-item');
      const bg = button.querySelector('.accordion__button-collapse');
      if (itemId === buttonId) {
        const alreadyOpen = bg?.classList.contains(activeButtonClass);
        if (alreadyOpen) bg?.classList.remove(activeButtonClass);
        else bg?.classList.add(activeButtonClass);
      } else {
        bg?.classList.remove(activeButtonClass);
      }
    }

    for (const content of contentList) {
      const contentId = content.getAttribute('data-collapse-content');
      const item = content.querySelector(
        '.accordion__content-item'
      ) as HTMLElement;

      const resizeObservable = new ResizeObserver((e) => {
        const height = e[0].contentRect.bottom;
        const roundedHeight = Math.round(height);
        const contentHeight = Number(content.style.height.replace('px', ''));

        const isSameHeight = roundedHeight === contentHeight;
        const notClose = isSameHeight || contentHeight !== 0;
        content.style.height = `${notClose ? height : 0}px`;
      });

      if (itemId === contentId) {
        const alreadyOpen = content.classList.contains(activeContentClass);
        if (alreadyOpen) {
          content.classList.remove(activeContentClass);
          item?.classList.remove(activeContentItemClass);
          content.style.height = `0px`;
          resizeObservable.disconnect();
        } else {
          content.classList.add(activeContentClass);
          item?.classList.add(activeContentItemClass);
          const height = item?.scrollHeight;
          content.style.height = `${height}px`;

          if (!observableItems.includes(itemId)) {
            observableItems.push(itemId);
            resizeObservable.observe(item);
          }
        }
      } else {
        content.classList.remove(activeContentClass);
        item?.classList.remove(activeContentItemClass);
        content.style.height = `0px`;
        resizeObservable.disconnect();
      }
    }
  }
});
